import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { primaryColor } from "../../../../../../utils/comon";

const SuccessModal = ({ message, onClose }) => {
    const primary = primaryColor();
    return (
        <div className="flex-1 flex flex-col items-center justify-center h-full bg-[#F6F6F4] p-4 text-center">
            <div className="bg-white p-6 rounded-lg shadow-sm max-w-sm w-full relative">
                <button 
                    onClick={onClose} 
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                <div className="w-12 h-12 bg-green-100 text-green-500 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                </div>
                <h2 className="text-lg font-black text-gray-800 mb-1 tracking-tight">Success!</h2>
                <p className="text-xs text-gray-600 font-semibold leading-relaxed mb-4">{message}</p>
                <button
                  onClick={onClose}
                  className="w-full py-2 rounded-lg text-white text-xs font-black flex items-center justify-center gap-2 active:scale-95 transition-all shadow-sm"
                  style={{ backgroundColor: primary }}
                >
                  Close & New Check-In
                </button>
            </div>
        </div>
    );
};

export default SuccessModal;
